<template>
<div class="p-grid">
<div class="p-col-12">
	<div class="card">
		<h5>Redirigiendo a QRreader</h5>
	</div>
</div>
</div>

</template>

<script>
import SmartService from '../service/SmartService';
export default {
	data() {
		return {
			code: this.$route.query['code'],
		}
    },
    smartService: null,
    created() {
         this.smartService = new SmartService();
    },	    
    mounted() {
		this.login();
    },
    methods: {
        login(){
			this.smartService.setAmbiente();
			if (this.code !== undefined){
				this.smartService.autenticarIDU(this.code).then(data => {        	
					if(data!=null) {
						if (data.LoginStatus==="OK"){ 
							localStorage.token = data.Token;
							localStorage.tokenExt = data.ExternalToken;
							localStorage.cedula = data.Documento;
							localStorage.nombre= data.Nombre; 
							localStorage.tec_id = data.Id; 
							localStorage.multiplicador = 1; 
							this.$router.replace({ name: "Punto móvil" });
						} else {
							localStorage.tokenExt = data.ExternalToken;
							this.$router.replace({ name: "access" });
						}
					} else {
						console.log("persona is null");
						this.$router.replace({ name: "error" });
					}
				})
				.catch((e) => {
					console.log(e);
					this.$router.replace({ name: "error" });
					});
			}
			else {
				this.$router.replace({ name: "error" });
			}
		}
    }
};
</script>